import { SignupHeader } from '../SignupHeader'
import { TypographyStyles } from '@/styles'
import { Button, Image, Link, Text } from '@/ui'

export const Consult = () => (
  <div className="container mx-auto pt-16">
    <SignupHeader hideProgress />

    <div className="flex flex-col space-y-8 items-center">
      <Image
        src="https://heard-images.s3.amazonaws.com/assets/messages.svg"
        alt="chat bubbles with question mark"
        height={180}
        width={180}
      />

      <Text variant={TypographyStyles.DISPLAY_MD} textAlign="center">
        Let&apos;s chat
      </Text>

      <Text textAlign="center" className="w-3/4 mx-2">
        Based on your answers, we need more information from you to determine if
        we can serve you. Book a free 30 minute consult with our team to learn
        if Heard is right for your practice.
      </Text>

      <div className="flex flex-col items-center space-y-4 mt-12 w-1/2">
        <Button asChild className="grow max-w-md w-full">
          <Link href="https://www.joinheard.com/welcome-form">
            Book a Free Consult
          </Link>
        </Button>

        <Button variant="secondary" asChild className="grow max-w-md w-full">
          <Link href="https://www.joinheard.com">Return to Site</Link>
        </Button>
      </div>
    </div>
  </div>
)
